var map = {
	"./bootstrap.svg": 8983,
	"./c-sharp.svg": 841,
	"./electron.svg": 3245,
	"./express.svg": 2785,
	"./fastapi.svg": 6195,
	"./flask.svg": 8356,
	"./github.svg": 7394,
	"./javascript.svg": 5602,
	"./kotlin.svg": 1256,
	"./mongo.svg": 4465,
	"./nextjs.svg": 6545,
	"./nodejs.svg": 9338,
	"./python.svg": 969,
	"./react.svg": 8032,
	"./redux.svg": 1407,
	"./supabase.svg": 6529,
	"./swift.svg": 8212,
	"./tailwind.svg": 7571,
	"./tauri.svg": 7500,
	"./threejs.svg": 1588,
	"./typescript.svg": 3330,
	"./unity.svg": 2290,
	"./vite.svg": 6493,
	"./website.svg": 9386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;